import { Instance } from 'mobx-state-tree'
import { KeepUserSubscriptionResponseModelBase } from './KeepUserSubscriptionResponseModel.base'

/* The TypeScript type of an instance of KeepUserSubscriptionResponseModel */
export interface KeepUserSubscriptionResponseModelType
  extends Instance<typeof KeepUserSubscriptionResponseModel.Type> {}

/* A graphql query fragment builders for KeepUserSubscriptionResponseModel */
export {
  selectFromKeepUserSubscriptionResponse,
  keepUserSubscriptionResponseModelPrimitives,
  KeepUserSubscriptionResponseModelSelector
} from './KeepUserSubscriptionResponseModel.base'

/**
 * KeepUserSubscriptionResponseModel
 */
export const KeepUserSubscriptionResponseModel = KeepUserSubscriptionResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
